import classnames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import {
  Col,
  Row,
  Container,
  Label
} from "reactstrap";

import {
  Base64ToHtmlComponent
} from "components/Common/CombinedComponents";
class ThreeDForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (

      <Container>
        <Row  style={{ marginTop: "10px" }} >         
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Base64ToHtmlComponent base64Response={this.props.base64Response?.htmlFormSuccess ?? ""} />
          </Col>
        </Row>
        <Row>
          <div className="mt-5 text-center">
            <p><strong>© {new Date().getFullYear()} Morpara</strong></p>
          </div>
        </Row>
      </Container >
    );
  }
}

ThreeDForm.propTypes = {
  onCloseClick: PropTypes.func,
  base64Response: PropTypes.any,
  errorIcon: PropTypes.any,
  errorResult: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default (withTranslation()(ThreeDForm));
